import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { HttpHeadersService } from '../../core/shared-service/http-headers.service';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ScheduleUpdateRemoteUpdatesService {


  constructor(private httpClient: HttpClient, private rootScopeService: RootScopeService,
    private httpHeaderService: HttpHeadersService) {
}

public publishScheduleUpdate(data:any): Observable<any> {
const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
return this.httpClient.post(environment.servicePath + '/software_update/publish_remote_software',data, { headers});
}
}
